import { jsx as _jsx } from "react/jsx-runtime";
import { useStyleConfig, vui } from '../core';
import { PopoverContent } from '../popover';
import { cs } from '../utils';
import { useSelectContext } from './context';
/** Extends PopoverContent to display given content is an overlaying box. */
export const SelectContent = vui((props, ref) => {
    const { className, ...rest } = props;
    const styles = useStyleConfig('Select', useSelectContext());
    return (_jsx(PopoverContent, { className: cs('vui-selectContent', className), column: true, py: 1, ref: ref, ...styles.content, ...rest }));
});
SelectContent.displayName = 'SelectContent';
export default SelectContent;
